var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGooglePlay = function SvgGooglePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "3.3em",
    height: "1em",
    viewBox: "0 0 264 78"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__a",
    x1: 0.915,
    y1: 6.614,
    x2: -0.383,
    y2: 5.945,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__b",
    x1: 1.076,
    y1: 17.098,
    x2: -1.305,
    y2: 17.098,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__c",
    x1: 0.862,
    y1: 10.863,
    x2: -0.501,
    y2: 9.093,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__d",
    x1: -0.188,
    y1: 13.583,
    x2: 0.421,
    y2: 12.793,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8247"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8246"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8245",
    transform: "translate(-10 -10)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2924",
    width: 264,
    height: 78,
    rx: 5,
    transform: "translate(10 10)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8059",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22512",
    d: "M92.586 19.999a5.288 5.288 0 0 1-1.455 3.911 5.678 5.678 0 0 1-4.3 1.734 6.034 6.034 0 0 1-6.086-6.119 6.034 6.034 0 0 1 6.086-6.119 6.064 6.064 0 0 1 2.405.49 4.819 4.819 0 0 1 1.831 1.31l-1.035 1.034a3.962 3.962 0 0 0-3.208-1.388 4.53 4.53 0 0 0-4.549 4.678 4.608 4.608 0 0 0 7.822 3.372 3.694 3.694 0 0 0 .982-2.374h-4.255v-1.411h5.678a4.993 4.993 0 0 1 .084.882Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22513",
    d: "M101.582 15.107h-5.336v3.716h4.811v1.405h-4.811v3.716h5.336v1.439h-6.839V13.668h6.839Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22514",
    d: "M107.93 25.383h-1.51V15.107h-3.27v-1.439h8.05v1.439h-3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22515",
    d: "M117.026 25.383V13.668h1.5v11.715Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22516",
    d: "M125.208 25.383h-1.506V15.107h-3.272v-1.439h8.05v1.439h-3.272Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22517",
    d: "M143.719 23.869a6.083 6.083 0 0 1-8.589 0 5.991 5.991 0 0 1-1.726-4.344 5.991 5.991 0 0 1 1.726-4.344 6.064 6.064 0 0 1 8.581.008 5.989 5.989 0 0 1 1.734 4.336 6 6 0 0 1-1.726 4.344Zm-7.478-.982a4.506 4.506 0 0 0 6.365 0 4.585 4.585 0 0 0 1.3-3.362 4.585 4.585 0 0 0-1.3-3.362 4.506 4.506 0 0 0-6.365 0 4.591 4.591 0 0 0-1.3 3.362 4.591 4.591 0 0 0 1.3 3.362Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22518",
    d: "M147.557 25.383V13.668h1.833l5.692 9.112h.064l-.064-2.257v-6.855h1.505v11.715h-1.57l-5.955-9.556h-.064l.064 2.259v7.3Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22519",
    d: "M133.033 42.47a8.3 8.3 0 1 0 8.335 8.3 8.185 8.185 0 0 0-8.335-8.3Zm0 13.335a4.8 4.8 0 0 1-4.688-5.031 4.7 4.7 0 1 1 9.374 0 4.8 4.8 0 0 1-4.686 5.032ZM114.85 42.47a8.3 8.3 0 1 0 8.335 8.3 8.185 8.185 0 0 0-8.335-8.3Zm0 13.335a4.8 4.8 0 0 1-4.688-5.031 4.7 4.7 0 1 1 9.374 0 4.8 4.8 0 0 1-4.686 5.032ZM93.218 45.018v3.519h8.429a7.352 7.352 0 0 1-1.917 4.434 8.631 8.631 0 0 1-6.511 2.579 9.374 9.374 0 0 1 0-18.746 8.981 8.981 0 0 1 6.353 2.517l2.485-2.484a12.291 12.291 0 0 0-8.839-3.555 12.9 12.9 0 1 0 0 25.794 11.785 11.785 0 0 0 8.995-3.618 11.64 11.64 0 0 0 3.052-8.241 11.381 11.381 0 0 0-.189-2.2Zm88.462 2.735c-.691-1.855-2.8-5.283-7.109-5.283-4.278 0-7.831 3.364-7.831 8.3a8.126 8.126 0 0 0 8.241 8.3 8.258 8.258 0 0 0 6.92-3.68l-2.831-1.888a4.744 4.744 0 0 1-4.088 2.3 4.227 4.227 0 0 1-4.028-2.515l11.1-4.594Zm-11.324 2.769a4.556 4.556 0 0 1 4.34-4.844 3.212 3.212 0 0 1 3.083 1.761Zm-9.026 8.052h3.647V34.165h-3.647Zm-5.979-14.249h-.125a5.755 5.755 0 0 0-4.372-1.855 8.311 8.311 0 0 0 0 16.608 5.657 5.657 0 0 0 4.372-1.888h.125v1.2c0 3.177-1.7 4.875-4.434 4.875a4.6 4.6 0 0 1-4.184-2.958l-3.177 1.322a7.913 7.913 0 0 0 7.361 4.907c4.278 0 7.9-2.517 7.9-8.649V42.972h-3.466Zm-4.182 11.48a4.764 4.764 0 0 1-4.623-5 4.8 4.8 0 0 1 4.623-5.065c2.485 0 4.434 2.14 4.434 5.065 0 2.894-1.948 5.001-4.434 5.001Zm47.6-21.639h-8.729v24.408h3.641v-9.247h5.088c4.038 0 8.007-2.925 8.007-7.581s-3.966-7.579-8.004-7.579Zm.094 11.764h-5.182v-8.366h5.182a4.184 4.184 0 1 1 0 8.366Zm22.516-3.5c-2.638 0-5.371 1.162-6.5 3.735l3.235 1.351a3.451 3.451 0 0 1 3.329-1.79c1.884 0 3.8 1.13 3.831 3.142v.25a8.059 8.059 0 0 0-3.8-.941c-3.485 0-7.035 1.915-7.035 5.494 0 3.266 2.858 5.371 6.06 5.371a5.141 5.141 0 0 0 4.649-2.388h.125v1.883h3.518v-9.362c0-4.332-3.233-6.75-7.409-6.75Zm-.439 13.376c-1.195 0-2.858-.6-2.858-2.072 0-1.884 2.072-2.607 3.862-2.607a6.5 6.5 0 0 1 3.329.816 4.416 4.416 0 0 1-4.331 3.859Zm20.661-12.843-4.174 10.574h-.125l-4.334-10.582h-3.924l6.5 14.79-3.706 8.228h3.8l10.018-23.018Zm-32.81 15.611h3.643V34.167h-3.643Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8061"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22520",
    d: "M20.875 17.608a3.919 3.919 0 0 0-.9 2.743v43.18a3.915 3.915 0 0 0 .9 2.743l.144.141 24.19-24.189v-.57L21.02 17.465Z",
    transform: "translate(-.501 -2.889)",
    fill: "url(#google-play_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22521",
    d: "M40.962 42.427 32.9 34.36v-.57l8.066-8.066.182.105 9.552 5.428c2.728 1.55 2.728 4.086 0 5.637l-9.553 5.428Z",
    transform: "translate(11.81 4.977)",
    fill: "url(#google-play_svg__b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22522",
    d: "M53.016 38.248 44.768 30 20.435 54.334c.9.953 2.386 1.07 4.059.119l28.522-16.205",
    transform: "translate(-.061 9.051)",
    fill: "url(#google-play_svg__c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22523",
    d: "M53.016 34 24.494 17.8c-1.673-.951-3.159-.834-4.059.119L44.768 42.25Z",
    transform: "translate(-.061 -3.198)",
    fill: "url(#google-play_svg__d)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8060"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22524",
    d: "m52.834 34.132-28.34 16.1c-1.585.9-3 .842-3.913.021l-.146.144.144.143c.91.82 2.327.881 3.913-.021l28.524-16.205Z",
    transform: "translate(-.061 12.985)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22525",
    d: "M20.875 43.656a3.915 3.915 0 0 1-.9-2.743v.287a3.91 3.91 0 0 0 .9 2.741l.146-.144Z",
    transform: "translate(-.501 19.444)",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22526",
    d: "m46.764 32.535-9.735 5.531.182.182 9.553-5.428A3.427 3.427 0 0 0 48.81 30a3.633 3.633 0 0 1-2.046 2.535Z",
    transform: "translate(15.744 9.051)",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22527",
    d: "m24.934 18.083 38.075 21.633a3.633 3.633 0 0 1 2.046 2.534 3.422 3.422 0 0 0-2.046-2.819L24.934 17.8c-2.73-1.55-4.961-.262-4.961 2.862v.287c0-3.128 2.227-4.417 4.961-2.866Z",
    transform: "translate(-.501 -3.198)",
    fill: "#fff",
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  }))));
};
export default SvgGooglePlay;